import React from 'react';
import { Check } from 'lucide-react';
import { Container, Eyebrow, H2, Reveal, btn } from './shared';
import { useSiteConfig } from '../../lib/siteConfig';

const INCLUDED = [
  '12 Live-Calls in 4 Wochen, 1:1, nur du und ich, keine Gruppe',
  'Meine Analyse-Checkliste für jede Aktie, die du dir anschaust',
  'DCF-Bewertungsmodell in Excel, einsteigerfreundlich aufgebaut',
  'Börsen-Glossar & Turnaround-Guide zum Nachschlagen',
  'Videokurs & Zugang zu meinem Blog mit meinen laufenden Analysen',
  'WhatsApp-Support zwischen den Calls, Antwort innerhalb von 24 Stunden',
];

const SlotBar = ({ total, free }) => (
  <div className="mt-3 flex gap-1.5" aria-hidden="true" data-testid="slots-bar">
    {Array.from({ length: total }, (_, i) => (
      <span key={i} className={`h-2.5 flex-1 rounded-full ${i < total - free ? 'bg-white/15' : 'bg-slot'}`} />
    ))}
  </div>
);

const PriceCard = () => {
  const c = useSiteConfig();
  const soldOut = c.slots_free <= 0;
  return (
    <div className="rounded-[28px] border border-line bg-paper p-6 sm:p-9" data-testid="price-card">
      <p className="font-display text-lg font-bold text-white">1:1 Aktien-Mentoring</p>
      <p className="mt-4 flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <span className="gold-text font-display text-6xl font-extrabold tracking-tight" data-testid="price-amount">{c.price} €</span>
        <span className="text-sm font-medium text-ink">einmalig · kein Abo</span>
      </p>
      <p className="mt-3 text-[15px] leading-relaxed text-ink">
        Das sind rund {Math.round(c.price / 12)} € pro Live-Call. Dazu alle Unterlagen, die du dauerhaft behältst.
      </p>
      <div className="mt-6 rounded-[20px] bg-leaf p-5" data-testid="slots-box">
        <p className="font-semibold text-white">Start im {c.next_start}</p>
        <SlotBar total={c.slots_total} free={Math.max(0, c.slots_free)} />
        <p className="mt-3 text-sm leading-relaxed text-ink" data-testid="slots-box-text">
          {soldOut
            ? 'Aktuell ausgebucht. Bewirb dich für den nächsten Start.'
            : `Noch ${c.slots_free} von ${c.slots_total} Plätzen frei. Ich betreue maximal ${c.slots_total} Mentees pro Monat.`}
        </p>
      </div>
      <a href="#bewerbung" className={`${btn.primary} mt-6 w-full`} data-testid="pricing-apply-btn">
        {soldOut ? 'Für nächsten Start bewerben' : 'Jetzt kostenlos bewerben'}
      </a>
      <p className="mt-4 text-center text-xs leading-relaxed text-ink">
        Erst Kennenlern-Call, dann entscheidest du. Bezahlt wird erst, wenn wir beide sagen: passt.
      </p>
    </div>
  );
};

export const Pricing = () => (
  <section id="preis" className="scroll-mt-20 border-y border-line bg-navy py-20 sm:py-28" data-testid="pricing-section">
    <Container className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <Eyebrow>Was du bekommst</Eyebrow>
        <H2>Alles, was du brauchst. Und nichts, was du nicht brauchst.</H2>
        <ul className="mt-8 space-y-4">
          {INCLUDED.map((item, i) => (
            <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-white/85 sm:text-base" data-testid={`included-item-${i}`}>
              <Check size={20} className="mt-0.5 shrink-0 text-mint" aria-hidden="true" />
              {item}
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={100}><PriceCard /></Reveal>
    </Container>
  </section>
);
